import { ReactNode, FunctionComponent } from 'react';
import { withStyles, MaterialSymbol } from 'vopay';
import styles from './MissingDetailRow.module.scss';

const cn = withStyles(styles);

type MissingDetailRowProps = {
  label: ReactNode;
  errorMessage: string;
};

const MissingDetailRow: FunctionComponent<MissingDetailRowProps> = ({ label, errorMessage }) => (
  <div className={cn('container')}>
    <div className={cn('row')}>
      <span className={cn('label')}>{label}</span>
      <span className={cn('missingValue')}>-Missing-</span>
    </div>
    <div className={cn('errorRow')}>
      <MaterialSymbol icon="error" size="16px" color="#ef4444" family="rounded" />
      <span className={cn('errorMessage')}>{errorMessage}</span>
    </div>
  </div>
);

export default MissingDetailRow;
